import styled from "styled-components";
import usePwaInstall from "../hooks/usePwaInstall";
import { useLanguage } from "../contexts/LanguageContext";

const InstallAppButton = ({ asMenuItem = false }) => {
  const { t } = useLanguage();
  const {
    isInstalled,
    isIos,
    isHandheld,
    canInstall,
    canPrompt,
    showIosHelp,
    promptInstall,
  } = usePwaInstall();

  if (isInstalled || !canInstall) return null;

  return (
    <Wrap>
      <Action type="button" $asMenuItem={asMenuItem} onClick={promptInstall}>
        {isHandheld ? t("set.install") : t("set.installDesktop")}
      </Action>
      {showIosHelp && (
        <Hint>
          {isIos
            ? t("set.installIos")
            : canPrompt
              ? null
              : t("set.installChrome")}
        </Hint>
      )}
    </Wrap>
  );
};

export default InstallAppButton;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const Action = styled.button`
  ${(props) =>
    props.$asMenuItem
      ? `
    padding: 11px 12px;
    text-align: left;
    background: none;
    border: none;
    color: var(--ink);
    font-weight: 600;
    font-size: 14px;
    width: 100%;
    border-radius: 10px;
  `
      : `
    padding: 12px 16px;
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    border: none;
    background: var(--color-ink-solid);
    color: var(--color-cream);
    width: fit-content;
  `}

  &:hover {
    background: ${(p) => (p.$asMenuItem ? "var(--surface-2)" : "var(--color-ink-solid)")};
  }
`;

const Hint = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--ink-soft);
  padding: 0 2px;
`;
